export type LeadIgnoreLevel = "FIRST" | "SECOND" | "THIRD";

export interface LeadByWorker {
  id: string;
  leadLinkId: string;
  leadLinkName: string;
  ownerId: string;
  ownerUsername: string;
  telegramId: string;
  telegramNickname: string;
  telegramUsername: string;
  status: LeadStatus;
  note: string | null;
  profit: number;
  rating: LeadRating;
  createdAt: Date;
  updatedAt: Date;
}

export interface LeadByManager {
  id: string;
  curatorId: string;
  curatorTelegramUsername: string;
  managerId: string;
  managerUsername: string;
  teamleadId: string;
  teamleadUsername: string;
  masterTeamleadId: string;
  masterTeamleadUsername: string;
  telegramId: string;
  telegramNickname: string;
  telegramUsername: string;
  status: LeadStatus;
  note: string | null;
  isDead: boolean;
  rating: LeadRating;
  createdAt: Date;
  updatedAt: Date;
}

export interface LeadByHead {
  id: string;
  leadLinkId: string;
  leadLinkName: string;
  ownerId: string;
  ownerUsername: string;
  curatorId: string;
  curatorTelegramUsername: string;
  telegramId: string;
  telegramNickname: string;
  telegramUsername: string;
  status: LeadStatus;
  profit: number;
  createdAt: Date;
  updatedAt: Date;
}

export type LeadShares = {
  amount: number;
  isActive: boolean;
  userId: string;
  username: string;
};

export type LeadSurvey = {
  hasAnybodyForVerification: boolean;
  hasDeposit: boolean;
  isAdult: boolean;
  isFamiliarWithCrypto: boolean;
  isSecondTryUsed: boolean;
};

export enum LeadStatus {
  REJECTED = "REJECTED",
  FRESH = "FRESH",
  WARMING_UP = "WARMING_UP",
  SURVEY_IN_PROGRESS = "SURVEY_IN_PROGRESS",
  SURVEY_COMPLETED = "SURVEY_COMPLETED",
  REMOVED_BY_SURVEY = "REMOVED_BY_SURVEY",
  TEXTED = "TEXTED",
  IGNORE = "IGNORE",
  HAD_CALL = "HAD_CALL",
  SPINNING = "SPINNING",
  LOOKING_FOR_DEPOSIT = "LOOKING_FOR_DEPOSIT",
  DEPOSIT = "DEPOSIT",
  UNLINKED = "UNLINKED",
}

export enum LeadSearchBy {
  OWNER_USERNAME = "ownerUsername",
  CURATOR_TG_USERNAME = "curatorTelegramUsername",
  TG_USERNAME = "telegramUsername",
  TG_ID = "telegramId",
  TG_NICKNAME = "telegramNickname",
  REF_NAME = "refName",
  WITHOUT_CURATOR = "withoutCurator",
}

export enum LeadSource {
  NEUTRAL = "NEUTRAL",
  VERTEX = "VERTEX",
  HELPER = "HELPER",
  NEXUS = "NEXUS",
  ASTREON = "ASTREON",
  P2P_WORK = "P2P_WORK",
  GLAVION = "GLAVION",
  WAVIUM = "WAVIUM",
  REMOTE_PRO = "REMOTE_PRO",
  AXYON = "AXYON",
  VIBE_TEAM = "VIBE_TEAM",
}

export enum LeadRating {
  ONE = "one",
  TWO = "two",
  THREE = "three",
  FOUR = "four",
  FIVE = "five",
  SIX = "six",
  SEVEN = "seven",
  EIGHT = "eight",
  NINE = "nine",
  TEN = "ten",
}

export interface WorkerOLDUser {
  _id: string;
  username: string;
  password: string;
  role: string;
  permissions: string[];
  banned: boolean;
  tgId: string | null;
  tgIsPreferred: boolean;
  tgCode: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface WorkerOLDBalance {
  _id: string;
  asset: string;
  user: string;
  balance: number;
  totalIncome: number;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface WorkerOLD {
  _id: string;
  user: WorkerOLDUser;
  profitAlias: string;
  isAnonymousModeEnabled: boolean;
  isFree: boolean;
  totalProfit: number;
  lastPush: string | null;
  pushCount: number;
  totalLeadsCount: number;
  closedLeadsCount: number;
  lastLeadEnterAt: string | null;
  activeCommissionExclusionsCount: number;
  createdAt: string;
  updatedAt: string;
  __v: number;
  balances: WorkerOLDBalance[];
}